import { useDispatch, useSelector } from 'react-redux'
import type { AppDispatch, AppState } from '@/app/store/store'

export const useFeatureDispatch = useDispatch.withTypes<AppDispatch>()
export const useFeatureSelector = useSelector.withTypes<AppState>()
